import { batch } from 'react-redux';
import ValidationStatus from '../../Data/ValidationStatus';
import { validatePhoneSaga } from '../../Lib/redux/sagas/ValidatePhone/validatePhone';
import {
  setComponentValidationStatus,
  setPhoneValidationConstraint,
} from '../../Lib/redux/slices/components';
import { getPhonePlugin } from './phoneNumberInput.helpers';
import { handleAnswerQuestionSideEffectsSaga } from '../../Hooks/actionCreators';

/**
 * Handles the validation of a phone number
 *
 * @param {string} componentId
 * @param {string} countryCode - i.e. US / GB / FR
 * @param {fn} dispatch - function to dispatch an action
 * @param {string} iFrameId
 * @param constraints
 * @param {string|int|undefined} formId
 * @returns undefined
 */
const validatePhone = ({
  value,
  componentId,
  countryCode,
  dispatch,
  iFrameId,
  constraints,
  formId,
}) => {
  const plugin = getPhonePlugin(componentId);
  let valid;
  let number;
  let countryDialCode;

  if (plugin) {
    valid = plugin.isValidNumber();
    const intlNumberFormat = window.intlTelInputUtils?.numberFormat?.E164 || 0;
    number = plugin.getNumber(intlNumberFormat);
    countryDialCode = `+${plugin.getSelectedCountryData().dialCode}`;
  }

  const isPluginInitialized = valid !== null;

  const intTelInputSaysInvalid =
    plugin &&
    isPluginInitialized &&
    (valid === false || !number.includes(countryDialCode));

  if (intTelInputSaysInvalid) {
    batch(() => {
      dispatch(
        setPhoneValidationConstraint({
          status: ValidationStatus.INVALID,
          componentId,
        })
      );
      dispatch(
        setComponentValidationStatus({
          componentId,
          countryCode,
          iFrameId,
          formId,
        })
      );
    });
  } else if (countryCode === 'GB' || countryCode === 'US') {
    batch(() => {
      dispatch(
        validatePhoneSaga({
          country: countryCode,
          number: value, // on condition the !pluginInitialized
          componentId,
          iFrameId,
          constraints,
          formId,
        })
      );
    });
  } else {
    batch(() => {
      dispatch(
        setPhoneValidationConstraint({
          status: ValidationStatus.VALID,
          componentId,
        })
      );
      dispatch(
        setComponentValidationStatus({
          componentId,
          countryCode,
          iFrameId,
          formId,
        })
      );
      dispatch(handleAnswerQuestionSideEffectsSaga({ componentId }));
    });
  }
};

export default validatePhone;
